class HeroBanner extends HTMLElement {
  constructor() {
    super();
    this.settings = {
      enableAnimation: this.dataset.enablePaddingAnimation === "true",
    };
  }

  connectedCallback() {
    if (this.settings.enableAnimation) {
      this.animateSidePadding();
    }
  }

  animateSidePadding() {
    console.log("running hero banner");
    const el = this;
    function clamp(value, min = 0, max = 1) {
      return Math.min(Math.max(value, min), max);
    }

    function update() {
      const viewportMid = window.innerHeight / 2;
      const rect = el.getBoundingClientRect();
      const elementMid = rect.top + rect.height / 2;

      // Progress as element crosses viewport center
      const progress = clamp((viewportMid - elementMid) / 200);

      el.style.setProperty("--progress", progress);
    }

    let ticking = false;
    function onScroll() {
      if (!ticking) {
        requestAnimationFrame(() => {
          update();
          ticking = false;
        });
        ticking = true;
      }
    }

    window.addEventListener("scroll", onScroll, { passive: true });
  }
}

if (!customElements.get("hero-banner")) {
  customElements.define("hero-banner", HeroBanner);
}
